// @deprecated – replaced by PermitForm

import { useMemo } from 'react';
import { useRequest, useJpa } from '@stores';
import { connect } from 'redux-bundler-react';

import IPFormInstructions from '@forms/static-forms/IPForm2aInstructions';
import SupportingInformation from '@forms/input-forms/common/SupportingInformation';
import Contacts from '@forms/input-forms/common/Contacts';
import PermitsFormOtherLawsRegulations from '@pages/Forms/input-forms/PermitsForm/otherLawsAndRegulations/PermitsFormOtherLawsRegulations';
import PermitsFormAdjoiningPropertyOwners from '@forms/input-forms/PermitsForm/PermitsFormAdjoiningPropertyOwners';
import { PermitFormAquaticResources } from '@forms/input-forms/common/AquaticResources';
import PermitFormImpactsMitigation from '@forms/input-forms/PermitsForm/impactsAndMitigation/PermitsFormImpactsMitigation.old';
import PermitsFormCertifySignSubmit from '@forms/input-forms/PermitsForm/PermitsFormCertifySignSubmit';
import JpaInfo from './JpaInfo';
import JpaForm, { generateJpaFormName } from './JpaForm';
import GeneralProjectInformation from '@forms/input-forms/common/GeneralProjectInformation';
import DaPermitInformation from '@forms/input-forms/PermitsForm/generalProjectInformation/DaPermitInformation';

//List of steps for vertical stepper, these can also be used for form header. index = step ID
export const getIpForm2aMetadata = () => {
  const baseFormArray = [
    IPFormInstructions.metadata,
    Contacts.metadata,
    GeneralProjectInformation.metadata,
    DaPermitInformation.metadata,
    PermitsFormAdjoiningPropertyOwners.metadata,
    PermitsFormOtherLawsRegulations.metadata,
    PermitFormAquaticResources.metadata,
    PermitFormImpactsMitigation.metadata,
    SupportingInformation.metadata,
    PermitsFormCertifySignSubmit.metadata,
  ];
  const jpaBasicInfo = useJpa.getState().jpaBasicInfo;
  const isJpa = jpaBasicInfo?.length > 0;

  // insert JPA sidebar steps
  if (isJpa) {
    const jpaInformationSteps = [
      {
        id: 'jpa-info',
        sectionName: 'Location Specific Information',
        isParentStep: true,
      },
    ];
    const jpaQuestionSteps = [
      {
        id: 'jpa-questions',
        sectionName: 'Location Specific Questions',
        isParentStep: true,
      },
    ];

    jpaBasicInfo.forEach((jpa) => {
      jpaInformationSteps.push({
        sectionName: generateJpaFormName(jpa),
        isSubStep: true,
        parentId: 1,
      });
      jpaQuestionSteps.push({
        sectionName: generateJpaFormName(jpa),
        isSubStep: true,
        parentId: jpaBasicInfo?.length + baseFormArray.length - 1,
      });
    });

    baseFormArray.splice(1, 0, ...jpaInformationSteps);
    baseFormArray.splice(baseFormArray.length - 2, 0, ...jpaQuestionSteps);
  }

  return baseFormArray;
};

const generateSections = ({
  doUpdatePermitRequest,
  isJpa,
  jpaBasicInfo,
  permitData,
  permitRequestID,
  onChange = () => {},
}) => {
  const sections = [
    {
      id: 'IP2aInstructions',
      name: 'Instructions',
      content: IPFormInstructions,
    },
    {
      id: 'IPFormContactInformation',
      name: 'Contact Information',
      content: Contacts,
      subtext: 'requesting an individual (or standard) permit for the proposed activity.',
      isPermit: true,
      componentID: permitRequestID,
    },
    {
      id: 'GeneralProjectInformation',
      name: 'General Project Information',
      content: GeneralProjectInformation,
    },
    {
      id: 'PermitInformation',
      name: 'Permit Information',
      content: DaPermitInformation,
    },
    {
      id: 'IPAdjoiningPropertyOwners',
      name: 'Adjoining Property Owners',
      content: PermitsFormAdjoiningPropertyOwners,
    },
    {
      id: 'IPOtherLawsAndRegulations',
      name: 'Other Laws And Regulations',
      content: PermitsFormOtherLawsRegulations,
    },
    {
      id: 'IPFormAquaticResources',
      name: 'Aquatic Resources',
      content: PermitFormAquaticResources,
    },
    {
      id: 'IPProjectImpactsAndMitigation',
      name: 'Project Impact and Mitigation',
      content: PermitFormImpactsMitigation,
    },
    {
      id: 'IP2aSupportingInformation',
      name: 'Supporting Information',
      content: SupportingInformation,
      componentID: permitRequestID,
      subtext: (
        <p>
          Please upload supporting documentation including project plans, state water certifications, etc. Multiple
          documents of the same file type can be combined and uploaded as one document.
        </p>
      ),
      updateRequestData: doUpdatePermitRequest,
    },
    {
      id: 'IP2aCertifySignSubmit',
      name: 'Certify Sign Submit',
      content: PermitsFormCertifySignSubmit,
    },
  ];

  // insert JPA content
  if (isJpa) {
    const jpaInfoSections = [
      {
        id: 'jpa-info',
        name: 'Location Specific Information',
        content: () => <></>,
      },
    ];
    const jpaFormSections = [
      {
        id: 'jpa-questions',
        name: 'Location Specific Questions',
        content: () => <></>,
      },
    ];

    const infoStartIndex = 1;
    const formStartIndex = sections.length + jpaBasicInfo.length - 1;
    const infoGroupIndexes = [];
    const formGroupIndexes = [];

    jpaBasicInfo.forEach((_, jpaIndex) => {
      infoGroupIndexes.push(jpaIndex + infoStartIndex + 1);
      formGroupIndexes.push(jpaIndex + formStartIndex + 1);
    });
    jpaBasicInfo.forEach((jpa) => {
      jpaInfoSections.push({
        id: `jpa-info-${jpa.formID}`,
        name: generateJpaFormName(jpa),
        content: JpaInfo,
        componentId: permitRequestID,
        formId: jpa.formID,
        group: {
          indexes: infoGroupIndexes,
          parentIndex: infoStartIndex,
          parentName: jpaInfoSections[0].name,
        },
        requestId: permitData.requestID,
        version: permitData.version,
        onChange: onChange,
      });
      jpaFormSections.push({
        id: `jpa-questions-${jpa.formID}`,
        name: generateJpaFormName(jpa),
        content: JpaForm,
        componentId: permitRequestID,
        formId: jpa.formID,
        group: {
          indexes: formGroupIndexes,
          parentIndex: formStartIndex,
          parentName: jpaFormSections[0].name,
        },
        requestId: permitData.requestID,
        version: permitData.version,
        onChange: onChange,
      });
    });
    sections.splice(1, 0, ...jpaInfoSections);
    sections.splice(sections.length - 2, 0, ...jpaFormSections);
  }

  return sections;
};

const IPForm2a = connect(
  'doUpdatePermitRequest',
  'selectPermitRequestID',
  'selectPermitData',
  ({ doUpdatePermitRequest, permitRequestID, permitData }) => {
    const { jpaBasicInfo } = useJpa();
    const { getActiveSection } = useRequest();
    const activeStep = getActiveSection();
    const isJpa = jpaBasicInfo?.length > 0;

    const sections = useMemo(
      () => generateSections({ doUpdatePermitRequest, isJpa, jpaBasicInfo, permitData, permitRequestID }),
      [doUpdatePermitRequest, isJpa, jpaBasicInfo, permitData, permitRequestID]
    );

    return sections.map((section, i) => {
      const { content: Content, ...props } = section;
      return (
        <section
          id={section.id}
          key={section.id}
          name={section.name}
          style={{ display: activeStep?.id === i ? 'inline' : 'none' }}
        >
          <Content stepNo={i} {...props} {...section.props} />
        </section>
      );
    });
  }
);

export default IPForm2a;
